import { useEffect } from 'react'

import { setSeonSessionIdToDB } from 'services/seon'
import { useAppSelector } from 'store/hooks'
import { isLoggedInSelector } from 'store/modules/user/selectors'
import { yieldToMain } from 'utils/yieldToMain'

export default function useSeonInit() {
  const isLoggedIn = useAppSelector(isLoggedInSelector)

  useEffect(() => {
    if (isLoggedIn) {
      yieldToMain().then(setSeonSessionIdToDB) // [FYI]: checking session storage for existing seon token and sending to BE
    }
  }, [isLoggedIn])
}
